import { FormHelperText } from "@mui/material";
import { styled } from "@mui/system";

const StyledFormHelperTextCustom = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1)
}));
export default StyledFormHelperTextCustom;
